import { gql } from '@apollo/client';
import { ACTOR_FIELDS_FRAGMENT } from './fragments';

/**
 * Actor GraphQL Mutations - 8 mutations for Formula #1/#6 support
 */

export const CREATE_ACTOR = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  mutation CreateActor($tenantId: String!, $input: GqlCreateActorInput!) {
    createActor(tenantId: $tenantId, input: $input) {
      ...ActorFields
    }
  }
`;

export const UPDATE_ACTOR = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  mutation UpdateActor($tenantId: String!, $actorId: String!, $input: GqlUpdateActorInput!) {
    updateActor(tenantId: $tenantId, actorId: $actorId, input: $input) {
      ...ActorFields
    }
  }
`;

export const ASSIGN_TASK_TO_ACTOR = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  mutation AssignTaskToActor($tenantId: String!, $actorId: String!, $input: GqlAssignTaskToActorInput!) {
    assignTaskToActor(tenantId: $tenantId, actorId: $actorId, input: $input) {
      ...ActorFields
    }
  }
`;

export const COMPLETE_TASK_FOR_ACTOR = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  mutation CompleteTaskForActor($tenantId: String!, $actorId: String!, $taskId: String!, $success: Boolean!) {
    completeTaskForActor(tenantId: $tenantId, actorId: $actorId, taskId: $taskId, success: $success) {
      ...ActorFields
    }
  }
`;

export const UPDATE_ACTOR_STATUS = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  mutation UpdateActorStatus($tenantId: String!, $actorId: String!, $status: GqlActorStatus!, $reason: String) {
    updateActorStatus(tenantId: $tenantId, actorId: $actorId, status: $status, reason: $reason) {
      ...ActorFields
    }
  }
`;

export const RESET_CIRCUIT_BREAKER = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  mutation ResetCircuitBreaker($tenantId: String!, $actorId: String!) {
    resetCircuitBreaker(tenantId: $tenantId, actorId: $actorId) {
      ...ActorFields
    }
  }
`;

export const DEPRECATE_ACTOR = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  mutation DeprecateActor($tenantId: String!, $actorId: String!, $reason: String!) {
    deprecateActor(tenantId: $tenantId, actorId: $actorId, reason: $reason) {
      ...ActorFields
    }
  }
`;

export const ADD_ACTOR_TO_QUEUE = gql`
  ${ACTOR_FIELDS_FRAGMENT}
  mutation AddActorToQueue($tenantId: String!, $actorId: String!, $queueId: String!) {
    addActorToQueue(tenantId: $tenantId, actorId: $actorId, queueId: $queueId) {
      ...ActorFields
    }
  }
`;
